import { gql } from "@apollo/client";

export const GET_BIDDING_DETAILS = gql`
  query GetBiddingDetails($listing_id: Int!) {
    ListingAuction {
      getBiddingDetails(listing_id: $listing_id) {
        listing_bidding_id
        sale_start_date
        sale_end_date
        min_offer_amount
        participation_fee
        status
        max_number_of_bidders
        current_number_of_bidders
      }
    }
  }
`;

export const GET_AUTH_BIDDING_DETAILS = gql`
  query GetBiddingDetails($listing_id: Int!) {
    ListingAuction {
      getBiddingDetails(listing_id: $listing_id) {
        listing_bidding_id
        sale_start_date
        sale_end_date
        min_offer_amount
        participation_fee
        status
        max_number_of_bidders
        current_number_of_bidders
        user_offer {
          id
          offer_amount
          submitted_at
        }
      }
    }
  }
`;

export const GET_AUTH_BIDDING_OFFER_BILL = gql`
  query GetBiddingOfferBill($listing_bidding_id: Int!, $offer_amount: Float!) {
    ListingAuction {
      getBiddingOfferBill(
        listing_bidding_id: $listing_bidding_id
        offer_amount: $offer_amount
      ) {
        total
        description {
          ar
          en
        }
      }
    }
  }
`;

export const SEND_BIDDING_OFFER_OTP = gql`
  mutation SendBiddingOfferOtp($listing_bidding_id: Int!) {
    ListingAuction {
      sendBiddingOfferOtp(listing_bidding_id: $listing_bidding_id)
    }
  }
`;

export const UPDATE_BIDDING_OFFER = gql`
  mutation VerifyOtpAndSubmitBiddingOffer(
    $otp_code: String!
    $listing_bidding_id: Int!
    $offer_amount: Float!
  ) {
    ListingAuction {
      verifyOtpAndSubmitBiddingOffer(
        listing_bidding_id: $listing_bidding_id
        otp_code: $otp_code
        offer_amount: $offer_amount
      )
    }
  }
`;

export const GET_AUTH_BIDDING_OFFERS = gql`
  query GetBiddingOffers($listing_bidding_id: Int!) {
    ListingAuction {
      listBiddingOffers(listing_bidding_id: $listing_bidding_id) {
        id
        user {
          user_id
          phone
          name
          img
        }
        offer_amount
        submitted_at
      }
    }
  }
`;
